import { Component } from '@angular/core';

@Component({
  selector: 'app-create-mbq',
  imports: [],
  templateUrl: './create-mbq.component.html',
  styleUrl: './create-mbq.component.scss'
})
export class CreateMbqComponent {

}
